import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from 'semantic-ui-react'

import './Properties.css'

class Properties extends React.PureComponent {
  render() {
    return (
      <Grid
        className='properties'
      >
        {
          _.map(this.props.content, (row) => (
            <Grid.Row key={row.key}>
              <Grid.Column width={4}>
                {row.key}
              </Grid.Column>
              <Grid.Column width={12}>
                {row.value}
              </Grid.Column>
            </Grid.Row>
          ))
        }
      </Grid>
    )
  }
}

Properties.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.node.isRequired,
      value: PropTypes.node.isRequired
    })
  ).isRequired
}

export default Properties



// WEBPACK FOOTER //
// ./src/components/elements/Properties.js